import { Link } from "react-router-dom";
import "./RegPulseUnsubscribe.css";

const RegPulseUnsubscribe = () => {
  return (
    <section className="regpulse-unsubscribe-page">
      <div className="regpulse-unsubscribe-card">
        <div className="regpulse-unsubscribe-header">
          <div className="regpulse-unsubscribe-mail-icon">x</div>

          <div>
            <p className="regpulse-unsubscribe-eyebrow">EvoNext RegPulse</p>
            <h1>You’ve been unsubscribed</h1>
            <p>Thanks for being a Evonext RegPulse subscriber.</p>
          </div>
        </div>

        <div className="regpulse-unsubscribe-body">
          <div className="regpulse-unsubscribe-check-icon">✓</div>

          <h2>All done.</h2>

          <p className="regpulse-unsubscribe-message">
            You won't receive any more Evonext RegPulse emails. Your personal data will
            be permanently deleted within 30 days.
          </p>

          <div className="regpulse-unsubscribe-divider" />

          <p className="regpulse-unsubscribe-muted">Changed your mind?</p>

          <Link to="/subscribe" className="regpulse-unsubscribe-resubscribe">
            Re-subscribe to Evonext RegPulse
          </Link>

          <Link to="/home" className="regpulse-unsubscribe-back">
            &lt; Back to evonext.ai
          </Link>
        </div>
      </div>
    </section>
  );
};

export default RegPulseUnsubscribe;